<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务成果确认</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="page-title text-center">服务成果确认</div>
            <div class="alert-area" v-if="Number(info.diff_money) !== 0">
                <el-alert
                    :closable="false"
                    title="本次服务成果确认将产生大额服务费，请您确认后再提交。"
                    type="error">
                </el-alert>
            </div>
            <div class="page-caption">
                <div class="cell">
                    <div class="cell__label">项目名称：</div>
                    <div class="cell__value">{{info.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">服务人员：</div>
                    <div class="cell__value">{{info.member}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">预计完成时间：</div>
                    <div class="cell__value">{{info.complete_time}}</div>
                </div>
            </div>
            <div class="page-content">
                <div class="caption">
                    <div class="cell">服务内容</div>
                    <div class="cell">单位</div>
                    <div class="cell">服务要求</div>
                     <div class="cell">需求数量</div>
                    <div class="cell">确认数量</div>
                    <div class="cell">奖励金额</div>
                    <div class="cell">预估单价</div>
                </div>
                <div class="box" v-for="(item, index) in info.service" :key="index">
                    <div class="cell">
                        <el-tooltip :content="item.name">
                            <div class="content-ellipsis">{{item.name}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.unit}}</div>
                    <div class="cell">
                        <el-tooltip :content="item.demand">
                            <div class="content-ellipsis">{{item.demand}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.amount}}</div>
                    <div class="cell">
                        {{item.count}}
                    </div>
                    <div class="cell">
                        {{item.award}}
                    </div>
                    <div class="cell">{{item.price}}</div>
                </div>
                <div class="box no-top-border">
                    <div class="cell">服务总计</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.to_pay_money}}</div>
                </div>
                <div class="box no-top-border">
                    <div class="cell">预计个税金额</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.tax}}</div>
                </div>
                <div class="box">
                    <div class="cell">大额服务费</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.diff_money}}</div>
                </div>
                <div class="box">
                    <div class="cell">预计实发金额</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.real_money}}</div>
                </div>
            </div>
            <div class="page-footer">
                <div class="handler-wraper">
                    <el-button type="default" style="margin-right: 20px;"
                               @click="goPage(`/index/project/detail?id=${info.id}&panel=1`)">返回
                    </el-button>
                    <el-button type="primary" @click="showQueryConfirm">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Detail',
    inject: ['goPage'],
    data () {
        return {
            userInfo: {},
            info: {
                service: []
            }
        }
    },
    mounted () {
        if (!localStorage.getItem('QRESULT')) {
            router.go(-1)
        }
        this.getUserInfo()
        this.getInfo()
    },
    methods: {
        getInfo () {
            try {
                this.info = JSON.parse(localStorage.getItem('QRESULT'))
                if (this.info && this.info.preview) {
                    try {
                        const p = this.info.preview || {}
                        this.info.tax = p.tax
                        this.info.diff_money = p.diff_money
                        this.info.real_money = p.real_money
                        this.info.to_pay_money = p.to_pay_money
                    } catch (e) {}
                }
                localStorage.removeItem('QRESULT')
            } catch (e) {
                this.$message.error({
                    message: '系统错误, 请重新提交确认成果',
                    center: true
                })
                router.go(-1)
            }
        },
        getUserInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                        localStorage.setItem('USERINFO', JSON.stringify(res.data))
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        showQueryConfirm () {
            const h = this.$createElement
            this.$msgbox({
                title: '服务成果确认',
                customClass: 'pay-msg-confirm',
                message: h('p', {
                    class: 'confirm-wrapper'
                }, [
                    h('i', {
                        class: ['el-icon-warning', 'text-error']
                    }),
                    h('span', {
                        class: 'confirm-text'
                    }, '请您仔细确认服务成果，一经支付，无法修改，请谨慎操作。 ')
                ]),
                showCancelButton: true,
                confirmButtonClass: 'confirm-customer-style',
                cancelButtonClass: 'confirm-customer-style',
                confirmButtonText: '确认无误',
                cancelButtonText: '返回检查'
            }).then(action => {
                this.onCommit()
            })
        },
        onCommit () {
            let arr = this.info.service.map(item => {
                return {
                    id: item.id,
                    amount: item.count,
                    award: item.award,
                    price: item.price
                }
            })
            this.$http.post('/api/user/project/subconfirmresults', qs.stringify({
                id: this.info.id,
                sub_id: this.info.sub_id,
                service: JSON.stringify(arr)
            }))
                .then((res) => {
                    if (res.code === 0) {
                        if (res.data.status === 100) {
                            // 不需要支付差额，直接提交
                            this.$notify.success({
                                title: '通知',
                                message: '提交成功'
                            })
                            localStorage.removeItem('QRESULT')
                            router.replace(`/index/project/detail?id=${this.info.id}&panel=1`)
                        } else {
                            // 需要支付差额，跳转
                            this.$notify.success({
                                title: '通知',
                                message: '提交成功,请尽快支付。'
                            })
                            localStorage.removeItem('QRESULT')
                            if (this.userInfo.role_id === 2) {
                                router.replace(`/index/project/servicecommited?id=${res.data.id}&sub_id=${res.data.sub_id}&pre_id=${res.data.pre_id}`)
                            } else {
                                router.replace(`/index/project/servicepayinfo?id=${res.data.id}&sub_id=${res.data.sub_id}&pre_id=${res.data.pre_id}`)
                            }
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$message.error('网络错误，请稍候再试。')
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";

    .page-title {
        padding-top: 43px;
        font-size: 20px;
        font-weight: bold;
    }

    .alert-area {
        margin-top: 25px;
        padding: 0 20px;
        margin-bottom: -10px;
    }

    .confirm-wrapper {
        display: flex;
        padding: 20px 0;
        .text-error {
            color: $--color-danger;
            font-size: 36px;
            margin-right: 15px;
        }
        .confirm-text {
            font-size: 16px;
        }
    }

    .page-caption {
        display: flex;
        margin-top: 25px;
        margin-bottom: 15px;
        padding: 0 20px;

        .cell {
            flex: 1;
            display: flex;

            &:nth-child(2) {
                justify-content: center;
            }

            &:last-child {
                justify-content: flex-end;
            }
        }
    }

    .page-content {
        padding: 0 20px;

        .caption {
            display: flex;
            background-color: #F5F5FA;
            color: #909399;
            border-bottom: 1px solid $--border-color-base;
            border-top: 1px solid $--border-color-base;
        }

        .box {
            display: flex;
            border-bottom: 1px solid $--border-color-base;
        }

        .cell {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 48px;
            padding-left: 10px;
            display: flex;
            align-items: center;

            &:nth-child(1) {
                width: 150px;
            }

            &:nth-child(2) {
                width: 100px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 100px;
            }

            &:nth-child(5) {
                width: 150px;
            }

            &:nth-child(6) {
                width: 150px;
            }

            &:nth-child(7) {
                width: 100px;
            }
        }
    }

    .page-footer {
        .handler-wraper {
            width: 322px;
            margin: 138px auto 0;

            button {
                width: 144px;
            }
        }
    }
</style>
